<template>
  <router-view v-if="!busy && presentation"
               :presentation="presentation"
               @updated="fetchData">
  </router-view>
</template>
<script>

import PresentationToolbar from './components/PresentationToolbar';

export default {
  components: {PresentationToolbar},
  metaInfo() {
    this.$store.commit('setTitle', this.presentation ? this.presentation.name : 'Presentation');
    return {
      title: this.$store.getters.title,
    }
  },
  data() {
    return {
      busy: false,
      breadcrumbs: [
        {text: 'Content', exact: true, to: {name: 'presentations'}},
        {text: 'Show',}
      ],
      presentation: null,
      types: {
        'card': 'card-heading, image',
      }
    }
  },
  computed: {
    presentationID() {
      return parseInt(this.$route.params.presentationID);
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.busy = true;
      const {data: presentation} = await axios.get(`/api/presentations/${this.presentationID}`)
      this.presentation = presentation;
      this.busy = false;
    }
  }
}
</script>
